import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import {
  LayoutDashboard,
  ShoppingCart,
  ChefHat,
  Package,
  ListTree,
  Megaphone,
  Settings,
  LogOut,
} from "lucide-react";
import UserService from "../../Modules/Services/user.service.ts";
import "./Admin.css";

const AdminLayout = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    UserService.logout();
    navigate("/login");
  };

  const links = [
    { to: "/admin/dashboard", key: "dashboard", icon: LayoutDashboard, label: "Дашборд" },
    { to: "/admin/orders", key: "orders", icon: ShoppingCart, label: "Заказы" },
    { to: "/admin/kitchen", key: "kitchen", icon: ChefHat, label: "Кухня" },
    { to: "/admin/products", key: "products", icon: Package, label: "Товары" },
    { to: "/admin/categories", key: "categories", icon: ListTree, label: "Категории" },
    { to: "/admin/promotions", key: "promotions", icon: Megaphone, label: "Акции" },
    { to: "/admin/settings", key: "settings", icon: Settings, label: "Настройки" },
  ];

  return (
    <div className="admin-shell">
      <aside className="admin-shell__sider">
        <div className="admin-shell__brand">
          <p className="admin-shell__brandName">Шахризада</p>
          <span className="admin-shell__brandTag">Админ</span>
        </div>
        <nav className="admin-nav" aria-label="Разделы админки">
          {links.map(({ to, key, icon: Icon, label }) => (
            <NavLink
              key={key}
              to={to}
              className={({ isActive }) =>
                `admin-nav__link ${isActive ? "is-active" : ""}`
              }
            >
              <Icon size={18} strokeWidth={2} aria-hidden />
              {label}
            </NavLink>
          ))}
        </nav>
      </aside>

      <div className="admin-shell__main">
        <header className="admin-shell__header">
          <button type="button" className="btn btn--ghost btn--small" onClick={handleLogout}>
            <LogOut size={16} strokeWidth={2} style={{ marginRight: 6 }} />
            Выйти
          </button>
        </header>
        <main className="admin-shell__contentWrap">
          <div className="admin-shell__contentInner">
            <Outlet />
          </div>
        </main>
        <footer className="admin-shell__footer">
          Shahrizadas Admin © {new Date().getFullYear()}
        </footer>
      </div>
    </div>
  );
};

export default AdminLayout;
